import { ThumbsDown, ThumbsUp } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { ChatFeedbackRating } from "@/types/chat-feedback";

interface Props {
  rating: ChatFeedbackRating;
  className?: string;
}

/**
 * 추천/비추 배지. `status-badge.tsx` 스타일과 일관:
 *  - shadcn Badge + 색상 클래스
 *  - 아이콘은 lucide-react (admin 전역 표준)
 *  - 이모지 사용하지 않음
 */
export function RatingBadge({ rating, className }: Props) {
  const isUp = rating === "up";
  const Icon = isUp ? ThumbsUp : ThumbsDown;
  const label = isUp ? "추천" : "비추";
  const tone = isUp
    ? "bg-emerald-100 text-emerald-800 border-emerald-300"
    : "bg-rose-100 text-rose-800 border-rose-300";
  return (
    <Badge
      variant="outline"
      className={cn(tone, "gap-1", className)}
      aria-label={`평가: ${label}`}
    >
      <Icon className="h-3 w-3" strokeWidth={2} />
      {label}
    </Badge>
  );
}
